/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  Client,
  ClientsState,
  ClientsActionTypes,
  CreateClientPayload,
  GetClientsPending,
  GetClientsSuccess,
  GetClientsError,
  CreateClientPending,
  CreateClientError,
  UpdateClientPayload,
  UpdateClientPending,
  UpdateClientSuccess,
  UpdateClientError,
  DeleteClientPending,
  DeleteClientError,
  SetClientId,
  InvalidateCachePending,
  InvalidateCacheError,
  DeleteTransactionsPending,
  DeleteTransactionsError,
  DeleteTransactionsPayload
} from './types';

// Actions
export const actions = {
  getClients: (): ClientsActionTypes => ({ type: types.GET_CLIENTS.REQUEST }),
  createClient: (payload: CreateClientPayload): ClientsActionTypes => ({
    type: types.CREATE_CLIENT.REQUEST,
    payload
  }),
  updateClient: (payload: UpdateClientPayload) => ({
    type: types.UPDATE_CLIENT.REQUEST,
    payload
  }),
  deleteClient: (payload: { id: string }): ClientsActionTypes => ({
    type: types.DELETE_CLIENT.REQUEST,
    payload
  }),
  setClientId: (payload: string): ClientsActionTypes => ({ type: types.SET_CLIENT_ID, payload }),
  invalidateCache: (): ClientsActionTypes => ({ type: types.INVALIDATE_CACHE.REQUEST }),
  deleteTransactions: (payload: DeleteTransactionsPayload): ClientsActionTypes => ({
    type: types.DELETE_TRANSACTIONS.REQUEST,
    payload
  }),
  resetAction: (): ClientsActionTypes => ({ type: types.RESET_ACTION }),
  resetError: (): ClientsActionTypes => ({ type: types.RESET_ERROR }),
  resetClients: (): ClientsActionTypes => ({ type: types.RESET_CLIENTS })
};

// Initial State
export const initialState: ClientsState = {
  clients: [],
  clientId: '',
  action: {
    success: false,
    pending: false,
    error: null
  }
};

// Reducer
export const reducer = (state: ClientsState = initialState, action: ClientsActionTypes): ClientsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_CLIENTS.PENDING:
      case types.CREATE_CLIENT.PENDING:
      case types.UPDATE_CLIENT.PENDING:
      case types.DELETE_CLIENT.PENDING:
      case types.INVALIDATE_CACHE.PENDING:
      case types.DELETE_TRANSACTIONS.PENDING:
        draft.action.pending = (
          action as
            | GetClientsPending
            | CreateClientPending
            | UpdateClientPending
            | DeleteClientPending
            | InvalidateCachePending
            | DeleteTransactionsPending
        ).payload;
        break;
      case types.GET_CLIENTS.SUCCESS:
        draft.clients = (action as GetClientsSuccess).payload;
        break;
      case types.CREATE_CLIENT.SUCCESS:
      case types.DELETE_CLIENT.SUCCESS:
      case types.INVALIDATE_CACHE.SUCCESS:
        draft.action.success = true;
        break;
      case types.DELETE_TRANSACTIONS.SUCCESS:
        break;
      case types.UPDATE_CLIENT.SUCCESS:
        const payload = (action as UpdateClientSuccess).payload;
        draft.action.success = true;
        if (draft.clients.length) {
          const clientIndex = draft.clients.findIndex((c) => c.id === (payload as Client).id);
          if (clientIndex > -1) {
            Object.assign(draft.clients[clientIndex], payload);
          }
        }
        break;
      case types.GET_CLIENTS.ERROR:
      case types.CREATE_CLIENT.ERROR:
      case types.UPDATE_CLIENT.ERROR:
      case types.DELETE_CLIENT.ERROR:
      case types.INVALIDATE_CACHE.ERROR:
      case types.DELETE_TRANSACTIONS.ERROR:
        draft.action.error = (
          action as
            | GetClientsError
            | CreateClientError
            | UpdateClientError
            | DeleteClientError
            | InvalidateCacheError
            | DeleteTransactionsError
        ).payload;
        break;
      case types.SET_CLIENT_ID:
        draft.clientId = (action as SetClientId).payload;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
      case types.RESET_CLIENTS:
        draft.clients = initialState.clients;
        break;
    }
  });
};
